import StrapiNullable from '~/infra/types/strapi-nullable';

export enum SocialContactEnum {
  TELEGRAM = 'telegram',
  WHATSAPP = 'whatsapp',
  MAX = 'max',
}

interface ISocialContact {
  id: number;
  link: string;
  type: SocialContactEnum;
  title: string;
}

type SocialContact = StrapiNullable<ISocialContact>;

export default SocialContact;
